<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <searchBar ref="searchBar"
                   :on-search="queryData"
                   @create-tour="createTour"
        ></searchBar>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">
        <auftraegeTable ref="auftraegeTable"
                        :table-data="data"
                        @page-changed="setPage"
        ></auftraegeTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import searchBar from '../predefined_tours/PredefinedTourSearchbar.vue';
import auftraegeTable from '../predefined_tours/PredefinedTourTable.vue';
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {
  decryptAES,
} from "@/shared/crypto";



export default {
  name: "PredefinedTourVerwaltung",
  components: {
    'searchBar':searchBar, 'auftraegeTable': auftraegeTable},
  data() {
    return {
      // SearchbarProps
      loader: undefined,
      data: [],
      currentPage: 1,
      isBauhof: false,
      query: {
        searchText: "",
        page: 1,
      },
      afterFirstQuery: false,
    }
  },
  watch: {
    currentTab(n, o) {
      if (this.afterFirstQuery) {
        this.$refs.searchBar.searchFilter();
      }
    },
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    this.$nextTick(() => {
      this.parseQuery()
      this.$refs.searchBar.setQuery(this.query);
      this.queryData(this.query.searchText);
    })
  },
  methods: {
    createTour() {
      this.$router.push("/auftraege/predefined_tour/new");
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.page) {
        this.query = {
          searchText: query.searchText,
          page: query.page,
        }
      }
    },
    responseOkFetch(response) {
      this.$refs.auftraegeTable.currentPage = 1;
      this.$refs.searchBar.onFirstSearch();
      if (response.status === 200) {
        let data = response.body.data;
        this.decryptData(data);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setPage(page) {
      this.query.page = page;
      this.$router.push({query: this.query}).then(() => {}).catch(err => {});
    },
    queryData(searchText) {
      this.query = {
        searchText: searchText,
        page: this.query.page,
      }
      this.$router.push({query: this.query}).then(() => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/predefined_tour'+
            "?search_text="+searchText
        ).then(this.responseOkFetch, this.responseError)
      }).catch(e => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/predefined_tour'+
            "?search_text="+searchText
        ).then(this.responseOkFetch, this.responseError)
      });
    },
    async decryptData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.hideLoader();
      this.data = data;
      this.$nextTick(() => {
        if (!this.afterFirstQuery) {
          this.$refs.auftraegeTable.changePage(this.query.page);
        }
        this.afterFirstQuery = true;
      })
    },
  },
}
</script>

<style scoped>
::v-deep .tab-content {
  display: none !important;
}

.bauhof-border {
  border-left: 5px solid #FBFBFB;
  border-right: 5px solid #FBFBFB;
}

</style>
<style>
.toast-pre-wrap {
  white-space: pre-wrap;
}
</style>
